import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleResponseCode } from "./utilities/helpers";
import GetProxy from "./GetProxy";
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const proxy = GetProxy();
export const getSecurityDetails = createAsyncThunk("get/SecurityDetails", async () => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(`${proxy}/aws/get/members/details`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "DTOP-API-TOKEN": apiToken,
        USERNAME: username,
      },
    });
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const saveProfilePic = createAsyncThunk(
  "post/saveProfilePic",
  async ({ file, payload }, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
     const formData = new FormData();
      formData.append("userName", payload?.userName);

      if (file){
      formData.append("image", file);
      }
      
    try {
      if (!apiToken || !username) {
        throw new Error("Missing required parameters");
      }

      
      const response = await fetch(`${proxy}/UserProfile/uploadProfileImage`, {
        method: "POST",
        headers: {
          "DTOP-API-TOKEN": apiToken,
          "USERNAME": username,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || "Upload failed");
      }
      handleResponseCode(response);
       const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Upload failed:", error);
      return rejectWithValue(error.message);
    }
  }
);
export const removeProfilePic = createAsyncThunk(
  "post/removeProfilePic",
  async ({ payload }, { rejectWithValue }) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

      
    try {      
      const response = await fetch(`${proxy}/UserProfile/removeImage/${payload?.userName}`, {
        method: "DELETE",
        headers: {
          "DTOP-API-TOKEN": apiToken,
          "USERNAME": username,
        },
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || "failed");
      }
      handleResponseCode(response);
       const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Upload failed:", error);
      return rejectWithValue(error.message);
    }
  }
);

const commonSlice = createSlice({
  name: "common",
  initialState: {
    submitrefresh: false,
    Assessment: "",
    isNavigatedUsingSideNav: true,
    sessionExtend: false,
    TimeoutId: null,
    sessionToken: false,
    currentPage: "Summary",
    offcanvasState: {
      isDrilldownOpen: false,
      title: "",
      dropDownMenuOptions: [],
      selectedValue: {},
      selectedData: [],
      handleDdMenuChange: () => {},
      isDropDownShown: true,
    },
    offcanvasThreeState: {
      isDrilldownThreeOpen: false,
      isCustomizeDrilldown: false,
      locDrilldown: false,
      title: "",
      static: false,
      selectedData: [],
      isDropDownShown: true,
      hideCVSSv2Score: false,
    },
    accordionModal: {
      accordionData: [],
    },
    offcanvasLastState: {
      isDrilldownLastOpen: false,
      title: "",
      static: false,
      selectedData: [],
      isDropDownShown: true,
    },
    drillDownSelectionState: {
      selectedLevelOne: "",
    },
    completeTable: {
      limit: 10,
      pageNo: 0,
      pageCount: "",
      listCount: "",
      activeKey: "",
      searchKey: "",
      filterKey: "",
    },
    loggedUser: {
      userName: "",
      userRole: "",
      /* The single role to show for the account. The auth response picks it
         off Roles.HIERARCHY, so it is one name already spelt for display —
         unlike userRole, which is the full list in backend spelling. */
      primaryRole: "",
      userMail: "",
      displayName: "",
      usersProfilePic: "",
      token: "",
    },
    ProjectStatusUpdate: {
      scanStatus: {},
    },
    commonAlert: {
      openAlert: false,
      alertType: "",
      alertMessage: "",
    },
    UserMail: {
      mailId: "",
    },
    isReload: "false",
    assessmentData: [],
    selectedIds: [],
    pageLoading: true,
    securitydetailsLoading: false,
    secuirtyDetails: [],
    complianceAssessmentStates: null,
    saveProfilePicRes: [],
    isSaveProfilePicLoading: false,
    removeProfilePicRes: [],
    isRemoveProfilePicLoading: false,
    reloadProfilePic: false,
  },
  reducers: {
    setIsOffCanvasOpen: {
      reducer(state, action) {
        state.offcanvasState = action.payload;
      },
    },
    setIsOffCanvasThreeOpen: {
      reducer(state, action) {
        if (!action.payload?.hideCVSSv2Score) {
          state.offcanvasThreeState.hideCVSSv2Score = false;
        }
        state.offcanvasThreeState = action.payload;
      },
    },
    setIsOffCanvasLastOpen: {
      reducer(state, action) {
        state.offcanvasLastState = action.payload;
      },
    },
    setSelectedLevelOne: {
      reducer(state, action) {
        state.drillDownSelectionState.selectedLevelOne = action.payload;
      },
    },
    setAccordionData: {
      reducer(state, action) {
        state.accordionModal.accordionData = action.payload;
      },
    },
    setCompleteTableLimit: {
      reducer(state, action) {
        state.completeTable.limit = action.payload;
      },
    },
    setCompleteTablePageNo: {
      reducer(state, action) {
        state.completeTable.pageNo = action.payload;
      },
    },
    setCompleteTablepageCount: {
      reducer(state, action) {
        state.completeTable.pageCount = action.payload;
      },
    },
    setCompleteTablelistCount: {
      reducer(state, action) {
        state.completeTable.listCount = action.payload;
      },
    },
    setCompleteTableactiveKey: {
      reducer(state, action) {
        state.completeTable.activeKey = action.payload;
      },
    },
    setCompleteTableSearchKey: {
      reducer(state, action) {
        state.completeTable.searchKey = action.payload;
      },
    },
    setCompleteTableFilterKey: {
      reducer(state, action) {
        state.completeTable.filterKey = action.payload;
      },
    },
    hideOffCanvas: {
      reducer(state, action) {
        state.offcanvasState.isDrilldownOpen = action.payload;
      },
    },
    hideOffCanvasThree: {
      reducer(state, action) {
        state.offcanvasThreeState.isDrilldownThreeOpen = action.payload;
      },
    },
    hideOffCanvasLast: {
      reducer(state, action) {
        state.offcanvasLastState.isDrilldownLastOpen = action.payload;
      },
    },

    locdrilldownthree: {
      reducer(state, action) {
        state.offcanvasThreeState.locDrilldown = action.payload;
      },
    },
    setSelectedDdMenuValue: {
      reducer(state, action) {
        state.offcanvasState.selectedValue = action.payload;
      },
    },
    setSelectedData: {
      reducer(state, action) {
        state.offcanvasState.selectedData = action.payload;
      },
    },
    setLoggedUser: {
      reducer(state, action) {
        state.loggedUser = action.payload;
      },
    },
    setProjectStatusUpdate: {
      reducer(state, action) {
        state.ProjectStatusUpdate = action.payload;
      },
    },
    setCommonAlert: {
      reducer(state, action) {
        state.commonAlert = action.payload;
      },
    },
    resetLoggedUser: {
      reducer(state) {
        state.loggedUser = {
          userName: "",
          userRole: "",
          primaryRole: "",
          userMail: "",
          token: "",
        };
        state.isNavigatedUsingSideNav = true;
      },
    },
    setUserMail: {
      reducer(state, action) {
        state.UserMail = action.payload;
      },
    },
    setIsReload: {
      reducer(state, action) {
        state.isReload = action.payload;
      },
    },
    setAssessmentData: {
      reducer(state, action) {
        state.assessmentData = action.payload;
      },
    },
    setSelectedIds: {
      reducer(state, action) {
        state.selectedIds = action.payload;
      },
    },
    setPageLoading: {
      reducer(state, action) {
        state.pageLoading = action.payload;
      },
    },
    setNavigationClicked: {
      reducer(state, action) {
        state.isNavigatedUsingSideNav = action.payload;
      },
    },
    setCurrentPage: {
      reducer(state, action) {
        state.currentPage = action.payload;
      },
    },
    setTableReload: {
      reducer(state, action) {
        state.tableReload = action.payload;
      },
    },
    setSessionExtend: {
      reducer(state, action) {
        state.sessionExtend = action.payload;
      },
    },
    setsubmitrefresh: {
      reducer(state, action) {
        state.submitrefresh = action.payload;
      },
    },
    setAssessment: {
      reducer(state, action) {
        state.Assessment = action.payload;
      },
    },
    setTimeoutId: {
      reducer(state, action) {
        state.TimeoutId = action.payload;
      },
    },
    setsessionToken: {
      reducer(state, action) {
        state.sessionToken = action.payload;
      },
    },
    setRiskAssessmentNavigationState: {
      reducer(state, action) {
        state.complianceAssessmentStates = {
          ...state.complianceAssessmentStates,
          ...action.payload,
        };
      },
    },
    setReloadProfilePic: {
      reducer(state, action) {
        state.reloadProfilePic = false;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      //SecurityDetails
      .addCase(getSecurityDetails.pending, (state, action) => {
        state.securitydetailsLoading = true;
      })
      .addCase(getSecurityDetails.fulfilled, (state, action) => {
        state.secuirtyDetails = action.payload;
        state.securitydetailsLoading = false;
      })
      .addCase(getSecurityDetails.rejected, (state, action) => {
        state.securitydetailsLoading = false;
      })

      .addCase(saveProfilePic.pending, (state) => {
        state.isSaveProfilePicLoading = true;
      })
      .addCase(saveProfilePic.fulfilled, (state, action) => {
        state.saveProfilePicRes = action.payload;
        state.reloadProfilePic = true;
        state.isSaveProfilePicLoading = false;
      })
      .addCase(saveProfilePic.rejected, (state) => {
        state.isSaveProfilePicLoading = false;
      })
      .addCase(removeProfilePic.pending, (state) => {
        state.isRemoveProfilePicLoading = true;
      })
      .addCase(removeProfilePic.fulfilled, (state, action) => {
        state.removeProfilePicRes = action.payload;
        state.reloadProfilePic = true;
        state.isRemoveProfilePicLoading = false;
      })
      .addCase(removeProfilePic.rejected, (state) => {
        state.isRemoveProfilePicLoading = false;
      });
  },
});
export const {
  setIsOffCanvasOpen,
  setIsOffCanvasThreeOpen,
  setIsOffCanvasLastOpen,
  setSelectedLevelOne,
  setCompleteTableLimit,
  setCompleteTablePageNo,
  setCompleteTablepageCount,
  setCompleteTablelistCount,
  setCompleteTableactiveKey,
  setCompleteTableSearchKey,
  setCompleteTableFilterKey,
  hideOffCanvas,
  hideOffCanvasThree,
  hideOffCanvasLast,
  locdrilldownthree,
  setSelectedDdMenuValue,
  setSelectedData,
  setLoggedUser,
  setProjectStatusUpdate,
  setCommonAlert,
  setUserMail,
  setIsReload,
  setPageLoading,
  setAssessmentData,
  setAssessment,
  setSelectedIds,
  setAccordionData,
  setNavigationClicked,
  setCurrentPage,
  setTableReload,
  resetLoggedUser,
  setSessionExtend,
  setTimeoutId,
  setsessionToken,
  setRiskAssessmentNavigationState,
  setsubmitrefresh,
  setReloadProfilePic
} = commonSlice.actions;


export default commonSlice.reducer;
